import React from 'react';
import {
    createBrowserRouter,
    RouterProvider,
  } from "react-router-dom";
import Main from '../../layout/Main';
import Catalogue from '../Catalogue/Catalogue';
import Fashion from '../Fashion/Fashion';
import Favourite from '../Favourite/Favourite';
import Home from '../Home/Home';
import Lifestyle from '../Lifestyle/Lifestyle';
import Notfound from '../NotFound/Notfound';
import Order from '../Order/Order';
import Single from '../Single/Single';

const Router = () => {

    const router = createBrowserRouter([
        {
          path: "/",
          element: <Main></Main>,
          children:[
            {
                path: "/",
                element: <Home></Home>,
              },
            {
                path: "home",
                element: <Home></Home>,
              },
            {
                path: "/catalogue",
                loader: async() =>{
                  return fetch('gameshop.json')
                },
                element: <Catalogue></Catalogue>,
              },
              {
                path: "/fashion",
                loader:async() =>{
                  return fetch('https://fakestoreapi.com/products')
                },
                element: <Fashion></Fashion>,
              },
              {
                path: "/product/:prodcutId",
                loader:async({params}) =>{
                  console.log(params.prodcutId)
                  return fetch(`https://fakestoreapi.com/products/${params.prodcutId}`)
                },
                element: <Single></Single>,
              },
              {
                path: "/favourite",
                element: <Favourite></Favourite>,
              },
              {
                path: "/order",
                element: <Order></Order>,
              },
              {
                path: "/lifestyle",
                element: <Lifestyle></Lifestyle>,
              },
              {
                path:'*',
                element: <Notfound></Notfound>
            }
          ]
        },
    
        
      ]);

    return (
        <div>
            <RouterProvider router={router}></RouterProvider>
        </div>
    );
};

export default Router;